import type { Product } from "../../lib/types";

/**
 * What a catalog item still needs for Lumi to explain it well and tell it apart from
 * similar ones. Products: model, category, description and specs. Services: description,
 * how long it takes and where it is given. Parts: description, code and what they fit.
 */
export function missingFields(
  p: Pick<Product, "kind" | "model" | "category" | "description" | "specs" | "durationMinutes" | "modalities" | "fits">,
): string[] {
  const missing: string[] = [];
  if (!p.description?.trim()) missing.push("descripción");
  if (p.kind === "part") {
    if (!p.model?.trim()) missing.push("código");
    if (!p.fits.length) missing.push("a qué modelos le sirve");
  } else if (p.kind === "service") {
    if (p.durationMinutes == null) missing.push("duración");
    if (!p.modalities.length) missing.push("dónde se da");
  } else {
    if (!p.model?.trim()) missing.push("modelo");
    if (!p.category?.trim()) missing.push("categoría");
    if (!p.specs.some((s) => s.label.trim() && s.value.trim())) missing.push("especificaciones");
  }
  return missing;
}
